// @ts-nocheck
import validateIsDateMinuteZero from "@store/Framework/Common/Utilities/validateIsDateMinuteZero";

export default (date: Date) => {
    const tempDate = new Date(date);
    return validateIsDateMinuteZero(date)
        ? tempDate.toLocaleTimeString("en-US", { hour: "numeric", timeZone: "Etc/UTC" })
        : tempDate.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZone: "Etc/UTC" });
};
